var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"cover",staticClass:"vimeo-wrapper h-100 w-100"},[_c('vue-vimeo-player',{ref:"vimeo",staticClass:"vimeo-player",style:(_vm.coverStyle),attrs:{"video-id":_vm.videoId,"autoplay":true,"loop":true,"options":_vm.vimeoPlayerVariables},on:{"loaded":_vm.vimeoVideoReady,"play":_vm.vimeoVideoPlaying}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }